import { useStoreRoot } from '~/stores/abstract/root';
import { useStoreCategoryPage } from '~/stores/strapi/categoryPage';
import { useStoreInfoPages } from '~/stores/strapi/infoPages';
import { useStoreProviders } from '~/stores/strapi/providers';
import { useStoreSlotTheme } from '~/stores/strapi/slotThemes';
import { strapi } from '~/stores/transport/strapi';
import { EPageType } from '~/types/pageType';

export default async function ({
  pageId,
  payload,
}: any): Promise<{ type: EPageType | null; data: any }> {
  if (payload && payload.type && payload.data) {
    switch (payload.type) {
      case EPageType.info:
        useStoreInfoPages().ADD_OR_EDIT_INFOPAGE_FROM_STRAPI(payload.data);
        return { type: payload.type, data: payload.data };
      case EPageType.provider:
        useStoreProviders().ADD_OR_EDIT_ONE_FROM_STRAPI(payload.data);
        return { type: payload.type, data: payload.data };
      case EPageType.category:
        return { type: payload.type, data: payload.data };
      case EPageType.slotTheme:
        return { type: payload.type, data: payload.data };
      default:
        return { type: EPageType.none, data: payload.data };
    }
  } else if (pageId) {
    const infoPageData = useStoreInfoPages().data.find(
      (el) => el.path === pageId && el.locale === useStoreRoot().userLang
    );

    const categoryPageData = useStoreCategoryPage().list.find(
      (el) =>
        el.descriptionText &&
        el.isPage &&
        el.categoryId === pageId &&
        el.locale === useStoreRoot().userLang
    );

    const slotThemeData = useStoreSlotTheme().list.find(
      (el) =>
        el.descriptionText && el.categoryId === pageId && el.locale === useStoreRoot().userLang
    );

    const providerPageData = useStoreProviders().providerPages.find(
      (el) =>
        el.descriptionText &&
        el.isPage &&
        el.providerId === pageId &&
        el.locale === useStoreRoot().userLang
    );

    if (infoPageData) {
      return {
        type: EPageType.info,
        data: infoPageData,
      };
    } else if (categoryPageData) {
      return {
        type: EPageType.category,
        data: categoryPageData,
      };
    } else if (categoryPageData) {
      return {
        type: EPageType.slotTheme,
        data: slotThemeData,
      };
    } else if (providerPageData) {
      return {
        type: EPageType.provider,
        data: providerPageData,
      };
    } else {
      const {
        infoPage: infoPageResponse,
        categoryPage: categoryPageResponse,
        slotTheme: slotThemeResponse,
        provider: providersPageResponse,
      } = await strapi().get('page/' + pageId);

      if (infoPageResponse && infoPageResponse.length) {
        useStoreInfoPages().ADD_OR_EDIT_INFOPAGE_FROM_STRAPI(infoPageResponse[0]);

        return { type: EPageType.info, data: infoPageResponse[0] };
      }
      if (categoryPageResponse && categoryPageResponse.length) {
        useStoreCategoryPage().ADD_OR_EDIT_ONE_FROM_STRAPI(categoryPageResponse[0]);

        return { type: EPageType.category, data: categoryPageResponse[0] };
      }
      if (slotThemeResponse && slotThemeResponse.length) {
        useStoreSlotTheme().ADD_OR_EDIT_ONE_FROM_STRAPI(slotThemeResponse[0]);

        return { type: EPageType.slotTheme, data: slotThemeResponse[0] };
      }
      if (providersPageResponse && providersPageResponse.length) {
        useStoreProviders().ADD_OR_EDIT_ONE_FROM_STRAPI(providersPageResponse[0]);

        return { type: EPageType.provider, data: providersPageResponse[0] };
      }
    }
  }

  return { type: EPageType.none, data: null };
}
